import { MuiProvider } from "./mui-provider";

const AppProvider = ({ children }: { children: React.ReactNode }) => {
  return <MuiProvider>{children}</MuiProvider>;
};

export default AppProvider;
